<script setup lang="ts">
import { computed, ref } from 'vue'
import fallbackImage from '@/assets/error-image.svg'

interface Props {
  src?: string,
  alt?: string,
  width?: string,
  height?: string,
  label?: string,
}
const props = defineProps<Props>()

const _source = ref<string>(props.src || '')
const _error = ref<boolean>(false)

const _class = computed(() => {
  return 'cs_image'
})

const _style = computed(() => {
  return ''
})

const onError = () => {
  // _source.value = fallbackImage
  _error.value = true
}

</script>

<template>
  <img
    :src="_source"
    :alt="props.alt || 'default image'"
    :width="props.width"
    :height="props.height"
    :class="_class"
    :style="_style"
    @error="onError"
    v-if="!_error && _source"/>
  <div class="cs-avatar" v-else>
    {{props.label}}
  </div>
</template>

<style scoped>

</style>
